export const HEADER_HEIGHT = 56;

export const CONTENT_MAX_WIDTH_ULTRAWIDE = 1920;
